/**
 * Created by Denis Kuzin on 22 august 2025
 */

const KingsCupMissionWindow = cc.Node.extend({
    ctor: function (mission, ...args) {
        this._super();

        this._windowArgs = [mission, ...args];
        const bundles = [`${mission.bundle}`];
        ComponentMap.attach(this, new WindowComponent(bundles));
    },

    onWindowLoaded: function (mission) {
        this.withShadow = true;

        this.mission = mission;

        const closeWindowCallback = () => {
            ComponentMap.get(this, WindowComponent).closeWindow();
        };

        const controller = this.controller = new KingsCupMissionWindowController({ mission, closeWindowCallback });
        ComponentMap.attach(this, controller);

        this.resizable = new Resizable({
            createHorizontalView: function () {
                return new KingsCupHorizontal(controller, { closeWindowCallback });
            },
            createVerticalView: function () {
                return new KingsCupVertical(controller, { closeWindowCallback });
            }
        });
        ComponentMap.attach(this, this.resizable);

        this.onResize();

        this.mission.updateCompetitionResults();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        if (this.resizable) {
            this.resizable.onResize();
        }
    },

    onShow: function () {
        this.controller.onShow();
    },

    onHide: function () {
        this.controller.onHide();
    },

    onClose: function () {
        this.controller.onClose();
    }
});

KingsCupLogic.prototype.getView = function () {
    if (this.unlocked) {
        return KingsCupMissionWindow;
    }

    return KingsCupStartWindow;
};